import { TState, TDispatch } from '../store'

export default {
  getIsLoading: (state: TState) => state.queues.isLoading,
  getIsLogsLoading: (state: TState) => state.queues.isLogsLoading,
  getQueuesList: (state: TState) => state.queues.queues,
  getQueueLogs: (state: TState) => state.queues.queueLogs,
}

